var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSqFeet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.436 9.4l-7.48-7.547a1.332 1.332 0 00-.947-.386c-.35.001-.685.14-.933.386L2.143 20.72a1.333 1.333 0 000 1.88l7.546 7.547a1.333 1.333 0 001.88 0l3.774-3.774 11.32-11.32 3.773-3.773a1.333 1.333 0 000-1.88zm-4.72 2.827l-.947-.947a1.334 1.334 0 10-1.88 1.893l.947.947L21.943 16l-2.827-2.827a1.333 1.333 0 00-1.88 1.88l2.827 2.827-1.894 1.893-.933-.946a1.338 1.338 0 10-1.893 1.893l.946.933-1.88 1.894-2.84-2.827a1.334 1.334 0 00-1.88 0 1.333 1.333 0 000 1.88l2.827 2.827-1.88 1.893-5.667-5.667L21.943 4.68l5.666 5.667-1.893 1.88z",
    fill: "#2C5BFF"
  })));
}
export default __webpack_public_path__ + "media/propertyTour/sq-feet-71426a1d.svg";
export { SvgSqFeet as ReactComponent };